import React from 'react';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

export const PurchaseOrderLogs = React.memo(() => {
  const { id } = useParams();
  return (
    <HasAccess role={PERMISSIONS.purchaseOrders.logs.read}>
      <div className={'logs-layout-container'}>
        <Logs entityName={'PURCHASE_ORDER'} id={id} />
      </div>
    </HasAccess>
  );
});
